const formatPercentage = (value?: number, decimalPoints: number = 1) => {
    if (!value || isNaN(value)) return '—';
    return `${(value * 100).toFixed(decimalPoints)}%`;
};

export default formatPercentage;